"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardanoWallet = void 0;
var WalletError_1 = require("../WalletError");
var Loader_1 = require("../../common/Loader");
var CoinSelection_1 = require("../../common/cardano/CoinSelection");
var buffer_1 = require("buffer");
var util_1 = require("../../common/util");
var bridge_1 = require("../../bridge");
var config_1 = require("./config");
var UTXO_LIMIT = 40;
var SUPPORTED_WALLETS = [
    config_1.CardanoWalletName.NAMI,
    config_1.CardanoWalletName.FLINT,
    config_1.CardanoWalletName.CARDWALLET,
];
var EXPERIMENTAL_WALLETS = [
    config_1.CardanoWalletName.ETERNL,
    config_1.CardanoWalletName.TYPHON,
    config_1.CardanoWalletName.YOROI,
    config_1.CardanoWalletName.NUFI,
];
var UNSUPPORTED_WALLETS = [
    config_1.CardanoWalletName.GEROWALLET,
];
var LANGUAGE_VIEWS = "a141005901d59f1a000302590001011a00060bc719026d00011a000249f01903e800011a000249f018201a0025cea81971f70419744d186419744d186419744d186419744d186419744d186419744d18641864186419744d18641a000249f018201a000249f018201a000249f018201a000249f01903e800011a000249f018201a000249f01903e800081a000242201a00067e2318760001011a000249f01903e800081a000249f01a0001b79818f7011a000249f0192710011a0002155e19052e011903e81a000249f01903e8011a000249f018201a000249f018201a000249f0182001011a000249f0011a000249f0041a000194af18f8011a000194af18f8011a0002377c190556011a0002bdea1901f1011a000249f018201a000249f018201a000249f018201a000249f018201a000249f018201a000249f018201a000242201a00067e23187600010119f04c192bd200011a000249f018201a000242201a00067e2318760001011a000242201a00067e2318760001011a0025cea81971f704001a000141bb041a000249f019138800011a000249f018201a000302590001011a000249f018201a000249f018201a000249f018201a000249f018201a000249f018201a000249f018201a000249f018201a00330da70101ff";
var CardanoWallet = /** @class */ (function () {
    function CardanoWallet(blockchainProvider) {
        if (blockchainProvider === void 0) { blockchainProvider = undefined; }
        if (blockchainProvider) {
            this.blockchainProvider = blockchainProvider;
        }
    }
    CardanoWallet.prototype.setBlockchainProvider = function (blockchainProvider) {
        this.blockchainProvider = blockchainProvider;
    };
    CardanoWallet.prototype.setBridgeProvider = function (bridgeProvider) {
        this.bridgeProvider = bridgeProvider;
    };
    CardanoWallet.prototype.getAvailableNames = function () {
        if (window.cardano === undefined) {
            console.warn("Cardano API not found");
            return [];
        }
        var names = [];
        for (var _i = 0, _a = __spreadArray(__spreadArray([], SUPPORTED_WALLETS, true), EXPERIMENTAL_WALLETS, true); _i < _a.length; _i++) {
            var name_1 = _a[_i];
            if (window.cardano[name_1]) {
                names.push(name_1);
            }
        }
        return names;
    };
    CardanoWallet.prototype.getNetworkId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var networkId, _a, cborAddresses;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_b.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        networkId = -1;
                        _a = this.walletName;
                        switch (_a) {
                            case config_1.CardanoWalletName.YOROI: return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._getCborUsedAddresses()];
                    case 3:
                        cborAddresses = _b.sent();
                        networkId = Loader_1.default.CSL.Address.from_bytes((0, util_1.HexToBuffer)(cborAddresses[0])).network_id();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.walletApi.getNetworkId()];
                    case 5:
                        networkId = (_b.sent());
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, networkId];
                }
            });
        });
    };
    CardanoWallet.prototype.apiVersion = function () {
        return this.wallet ? this.wallet.apiVersion : null;
    };
    CardanoWallet.prototype.name = function () {
        return this.wallet ? this.wallet.name : null;
    };
    CardanoWallet.prototype.icon = function () {
        return this.wallet ? this.wallet.icon : null;
    };
    CardanoWallet.prototype.isEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.wallet;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.wallet.isEnabled()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a && this.walletApi];
                }
            });
        });
    };
    CardanoWallet.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, auth, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!!(_c.sent())) return [3 /*break*/, 5];
                        // console.log("wallet:", this.wallet);
                        _a = this;
                        return [4 /*yield*/, this.wallet.enable()];
                    case 2:
                        // console.log("wallet:", this.wallet);
                        _a.walletApi = _c.sent();
                        if (!(this.walletName == config_1.CardanoWalletName.YOROI)) return [3 /*break*/, 5];
                        auth = this.walletApi.auth || this.walletApi.experimental.auth;
                        if (!auth) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, auth()];
                    case 3:
                        _b.walletAuth = _c.sent();
                        return [3 /*break*/, 5];
                    case 4: 
                    // console.warn("auth() is undefined");
                    return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CardanoWallet.prototype.login = function (walletName) {
        return __awaiter(this, void 0, void 0, function () {
            var wallet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.wallet = undefined;
                        this.walletApi = undefined;
                        this.walletAuth = undefined;
                        this.walletName = undefined;
                        if (!__spreadArray(__spreadArray([], SUPPORTED_WALLETS, true), EXPERIMENTAL_WALLETS, true).map(function (elem) { return elem.toString(); }).includes(walletName)) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.UNSUPPORTED_WALLET](walletName);
                        }
                        walletName = walletName.toLowerCase();
                        if (walletName === config_1.CardanoWalletName.TYPHON) {
                            walletName = "typhoncip30";
                        }
                        wallet = window.cardano[walletName];
                        if (!wallet) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_INSTALLED_WALLET](walletName);
                        }
                        if (EXPERIMENTAL_WALLETS.map(function (elem) { return elem.toString(); }).includes(walletName)) {
                            console.warn("".concat(walletName, " may be unstable. Use it carefully."));
                        }
                        this.wallet = wallet;
                        this.walletName = walletName;
                        return [4 /*yield*/, this.enable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ACCOUNT INFO */
    CardanoWallet.prototype._getCborUsedAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.walletApi.getUsedAddresses({
                            page: 0,
                            limit: 5,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CardanoWallet.prototype.getUsedAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cborAddresses, addresses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_a.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        return [4 /*yield*/, this._getCborUsedAddresses()];
                    case 2:
                        cborAddresses = _a.sent();
                        addresses = cborAddresses.map(function (addr) {
                            var _a;
                            return (_a = Loader_1.default.CSL.BaseAddress.from_address(Loader_1.default.CSL.Address.from_bytes((0, util_1.HexToBuffer)(addr)))) === null || _a === void 0 ? void 0 : _a.to_address().to_bech32();
                        });
                        addresses = addresses.filter(function (element) {
                            return element !== undefined;
                        });
                        return [2 /*return*/, addresses];
                }
            });
        });
    };
    CardanoWallet.prototype.getRewardAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, cborAddress, address;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_d.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        _b = (_a = console).log;
                        return [4 /*yield*/, this.walletApi.getRewardAddresses()];
                    case 2:
                        _b.apply(_a, [_d.sent()]);
                        return [4 /*yield*/, this.walletApi.getRewardAddresses()];
                    case 3:
                        cborAddress = (_d.sent())[0];
                        address = (_c = Loader_1.default.CSL.RewardAddress.from_address(Loader_1.default.CSL.Address.from_bytes((0, util_1.HexToBuffer)(cborAddress)))) === null || _c === void 0 ? void 0 : _c.to_address().to_bech32();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    CardanoWallet.prototype.getChangeAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cborAddress, address;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_b.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        return [4 /*yield*/, this.walletApi.getChangeAddress()];
                    case 2:
                        cborAddress = _b.sent();
                        address = (_a = Loader_1.default.CSL.BaseAddress.from_address(Loader_1.default.CSL.Address.from_bytes((0, util_1.HexToBuffer)(cborAddress)))) === null || _a === void 0 ? void 0 : _a.to_address().to_bech32();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    CardanoWallet.prototype.getAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getChangeAddress()];
            });
        });
    };
    CardanoWallet.prototype.signData = function (addr, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_a.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        return [2 /*return*/, this.walletApi.signData(addr, payload)];
                }
            });
        });
    };
    CardanoWallet.prototype._getCborBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.walletApi.getBalance()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CardanoWallet.prototype.getBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cborBalance, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_a.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        return [4 /*yield*/, this._getCborBalance()];
                    case 2:
                        cborBalance = _a.sent();
                        value = Loader_1.default.CSL.Value.from_bytes((0, util_1.HexToBuffer)(cborBalance));
                        return [2 /*return*/, CardanoWallet._valueToAssets(value)];
                }
            });
        });
    };
    CardanoWallet.prototype.getBalanceToken = function (unit) {
        return __awaiter(this, void 0, void 0, function () {
            var assets, filteredAsset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBalance()];
                    case 1:
                        assets = _a.sent();
                        filteredAsset = assets.filter(function (elem) { return elem.unit == unit; });
                        return [2 /*return*/, filteredAsset[0] ? filteredAsset[0].quantity : '0'];
                }
            });
        });
    };
    // TODO: replace to util
    CardanoWallet._valueToAssets = function (value) {
        var assets = [];
        assets.push({
            unit: 'lovelace',
            quantity: value.coin().to_str()
        });
        if (value.multiasset()) {
            var multiAssets = value.multiasset().keys();
            for (var j = 0; j < multiAssets.len(); j++) {
                var policy = multiAssets.get(j);
                var policyAssets = value.multiasset().get(policy);
                var assetNames = policyAssets.keys();
                for (var k = 0; k < assetNames.len(); k++) {
                    var policyAsset = assetNames.get(k);
                    var quantity = policyAssets.get(policyAsset);
                    var asset = buffer_1.Buffer.from(policy.to_bytes()).toString('hex') + "." +
                        buffer_1.Buffer.from(policyAsset.name()).toString('ascii');
                    assets.push({
                        unit: asset,
                        quantity: quantity.to_str(),
                    });
                }
            }
        }
        return assets;
    };
    CardanoWallet.prototype._getCborUtxos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, utxos, _b, _c, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.walletName;
                        switch (_a) {
                            case config_1.CardanoWalletName.NUFI: return [3 /*break*/, 1];
                            case config_1.CardanoWalletName.FLINT: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        _c = (_b = this.blockchainProvider).getAddressUtxos;
                        return [4 /*yield*/, this.getUsedAddresses()];
                    case 2:
                        _d = [(_e.sent())[0]];
                        return [4 /*yield*/, this.getNetworkId()];
                    case 3: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent()]))];
                    case 4:
                        utxos = _e.sent();
                        return [2 /*return*/, utxos.map(function (utxo) { return _this.toCborUtxo(utxo); })];
                    case 5: return [4 /*yield*/, this.walletApi.getUtxos()];
                    case 6: return [2 /*return*/, _e.sent()];
                }
            });
        });
    };
    CardanoWallet.prototype.getUtxos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hexUtxos, Utxos, UTXOS, _i, Utxos_1, utxo, value, assets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getCborUtxos()];
                    case 1:
                        hexUtxos = _a.sent();
                        Utxos = hexUtxos.map(function (utxo) { return Loader_1.default.CSL.TransactionUnspentOutput.from_bytes((0, util_1.HexToBuffer)(utxo)); });
                        UTXOS = [];
                        for (_i = 0, Utxos_1 = Utxos; _i < Utxos_1.length; _i++) {
                            utxo = Utxos_1[_i];
                            value = utxo.output().amount();
                            assets = CardanoWallet._valueToAssets(value);
                            UTXOS.push({
                                txHash: (0, util_1.HexToBuffer)(utxo.input().transaction_id().to_bytes()).toString('hex'),
                                txId: utxo.input().index(),
                                address: utxo.output().address().to_bech32(),
                                amount: assets
                            });
                        }
                        return [2 /*return*/, UTXOS];
                }
            });
        });
    };
    CardanoWallet.prototype.toUtxo = function (hexUtxos) {
        var Utxos = hexUtxos.map(function (utxo) { return Loader_1.default.CSL.TransactionUnspentOutput.from_bytes((0, util_1.HexToBuffer)(utxo)); });
        var UTXOS = [];
        for (var _i = 0, Utxos_2 = Utxos; _i < Utxos_2.length; _i++) {
            var utxo = Utxos_2[_i];
            var value = utxo.output().amount();
            var assets = CardanoWallet._valueToAssets(value);
            UTXOS.push({
                txHash: (0, util_1.HexToBuffer)(utxo.input().transaction_id().to_bytes()).toString('hex'),
                txId: utxo.input().index(),
                address: utxo.output().address().to_bech32(),
                amount: assets
            });
        }
        return UTXOS;
    };
    CardanoWallet.prototype.toCborUtxo = function (utxo) {
        var val = Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_str(utxo.amount[0]["quantity"]));
        var assets = utxo.amount.slice(1);
        if (assets.length > 0) {
            assets = assets.map(function (asset) {
                var policy = asset.unit.substring(0, 56);
                var name = asset.unit.substring(56);
                name = (0, util_1.HexToAscii)(name);
                return {
                    unit: "".concat(policy, ".").concat(name),
                    quantity: asset.quantity
                };
            });
            // console.log("Ku", assets);
            var multiAsset = CardanoWallet._makeMultiAsset(assets);
            val.set_multiasset(multiAsset);
        }
        var input = Loader_1.default.CSL.TransactionInput.new(Loader_1.default.CSL.TransactionHash.from_bytes((0, util_1.HexToBuffer)(utxo.tx_hash)), utxo.tx_index);
        var output = Loader_1.default.CSL.TransactionOutput.new(Loader_1.default.CSL.Address.from_bech32(utxo.address), val);
        return (0, util_1.BufferToHex)(buffer_1.Buffer.from(Loader_1.default.CSL.TransactionUnspentOutput.new(input, output).to_bytes()));
    };
    /* TRANSACTION HANDLING */
    // private static _initTxBuilderV9(protocolParameters: any) {
    //     const linearFee = Loader.CSL.LinearFee.new(
    //         Loader.CSL.BigNum.from_str(protocolParameters.min_fee_a.toString()),
    //         Loader.CSL.BigNum.from_str(protocolParameters.min_fee_b.toString())
    //     );
    //     const txBuilder = Loader.CSL.TransactionBuilder.new(
    //         // LinearFee (min_fee_a, min_fee_b)
    //         linearFee,
    //         // min_utxo
    //         Loader.CSL.BigNum.from_str("1000000" /* protocolParameters.min_utxo.toString() */), // TODO: update for protocolParameters value
    //         // pool_deposit
    //         Loader.CSL.BigNum.from_str(protocolParameters.pool_deposit.toString()),
    //         // key_deposit
    //         Loader.CSL.BigNum.from_str(protocolParameters.key_deposit.toString()),
    //         // max_value_size
    //         protocolParameters.max_val_size,
    //         // max_tx_size
    //         protocolParameters.max_tx_size,
    //         protocolParameters.price_mem,
    //         protocolParameters.price_step,
    //         Loader.CSL.LanguageViews.new(HexToBuffer(LANGUAGE_VIEWS))
    //     );
    //     return txBuilder;
    // }
    /*
    private static _initTxBuilderV10(protocolParameters: any) {
        const linearFee = Loader.CSL.LinearFee.new(
            Loader.CSL.BigNum.from_str(protocolParameters.min_fee_a.toString()),
            Loader.CSL.BigNum.from_str(protocolParameters.min_fee_b.toString())
        );

        const txBuilderCfg = Loader.CSL.TransactionBuilderConfigBuilder.new()
            .fee_algo(linearFee)
            .pool_deposit(Loader.CSL.BigNum.from_str(protocolParameters.pool_deposit.toString()))
            .key_deposit(Loader.CSL.BigNum.from_str(protocolParameters.key_deposit.toString()))
            .coins_per_utxo_word(Loader.CSL.BigNum.from_str(protocolParameters.coins_per_utxo_word.toString()))
            .max_value_size(protocolParameters.max_val_size)
            .max_tx_size(protocolParameters.max_tx_size)
            .prefer_pure_change(true)
            .build()

        const txBuilder = Loader.CSL.TransactionBuilder.new(txBuilderCfg);

        return txBuilder;
    }
    */
    CardanoWallet._initTxBuilderV11 = function (protocolParameters) {
        var linearFee = Loader_1.default.CSL.LinearFee.new(Loader_1.default.CSL.BigNum.from_str(protocolParameters.min_fee_a.toString()), Loader_1.default.CSL.BigNum.from_str(protocolParameters.min_fee_b.toString()));
        var txBuilderCfg = Loader_1.default.CSL.TransactionBuilderConfigBuilder.new()
            .fee_algo(linearFee)
            .pool_deposit(Loader_1.default.CSL.BigNum.from_str(protocolParameters.pool_deposit.toString()))
            .key_deposit(Loader_1.default.CSL.BigNum.from_str(protocolParameters.key_deposit.toString()))
            .coins_per_utxo_word(Loader_1.default.CSL.BigNum.from_str(protocolParameters.coins_per_utxo_word.toString()))
            .max_value_size(protocolParameters.max_val_size)
            .max_tx_size(protocolParameters.max_tx_size)
            .prefer_pure_change(true)
            .build();
        var txBuilder = Loader_1.default.CSL.TransactionBuilder.new(txBuilderCfg);
        return txBuilder;
    };
    CardanoWallet._makeMultiAsset = function (assets) {
        var AssetsMap = {};
        for (var _i = 0, assets_1 = assets; _i < assets_1.length; _i++) {
            var asset = assets_1[_i];
            var index = asset.unit.indexOf('.');
            var policy = asset.unit.slice(0, index);
            var assetName = asset.unit.slice(index + 1);
            var quantity = asset.quantity;
            if (!Array.isArray(AssetsMap[policy])) {
                AssetsMap[policy] = [];
            }
            AssetsMap[policy].push({
                "unit": (0, util_1.AsciiToHex)(assetName),
                "quantity": quantity
            });
        }
        var multiAsset = Loader_1.default.CSL.MultiAsset.new();
        for (var policy in AssetsMap) {
            var ScriptHash = Loader_1.default.CSL.ScriptHash.from_bytes((0, util_1.HexToBuffer)(policy));
            var Assets = Loader_1.default.CSL.Assets.new();
            var _assets = AssetsMap[policy];
            for (var _a = 0, _assets_1 = _assets; _a < _assets_1.length; _a++) {
                var asset = _assets_1[_a];
                var AssetName = Loader_1.default.CSL.AssetName.new(buffer_1.Buffer.from(asset.unit, 'hex'));
                var BigNum = Loader_1.default.CSL.BigNum.from_str(asset.quantity.toString());
                Assets.insert(AssetName, BigNum);
            }
            multiAsset.insert(ScriptHash, Assets);
        }
        return multiAsset;
    };
    CardanoWallet.prototype.buildTx = function (payer_1) {
        return __awaiter(this, arguments, void 0, function (payer, 
        // script = null,
        recipients, fee, metadata, ttl, networkId) {
            var _a, txBuilder, coinSelection, dataCost, datums, redeemers, plutusScripts, transactionWitnessSet, outputs, _i, recipients_1, recipient, txOutputBuilder, txOutputAmountBuilder, lovelace, outputValue, multiAsset, minAda, payerUtxos, selection, newFee, remainingLovelace, alwaysNeedLovelace, needLovelace, txOutputBuilder, txOutputAmountBuilder, lovelace, outputValue, minAda, err_1, i, auxiliaryData, generalTransactionMetadata_1, i, now, txBody, transaction, serializedTx;
            var _b, _c;
            if (recipients === void 0) { recipients = []; }
            if (fee === void 0) { fee = undefined; }
            if (metadata === void 0) { metadata = undefined; }
            if (ttl === void 0) { ttl = 3600; }
            if (networkId === void 0) { networkId = 0; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!this.protocolParameters) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, ((_b = this.blockchainProvider) === null || _b === void 0 ? void 0 : _b.getProtocolParameters(networkId))];
                    case 1:
                        _a.protocolParameters = _d.sent();
                        _d.label = 2;
                    case 2:
                        txBuilder = CardanoWallet._initTxBuilder(this.protocolParameters);
                        coinSelection = new CoinSelection_1.default();
                        coinSelection.setProtocolParameters(this.protocolParameters.min_utxo.toString(), this.protocolParameters.min_fee_a.toString(), this.protocolParameters.min_fee_b.toString(), this.protocolParameters.max_tx_size.toString(), this.protocolParameters.coins_per_utxo_word.toString());
                        dataCost = Loader_1.default.CSL.DataCost.new_coins_per_byte(Loader_1.default.CSL.BigNum.from_str(this.protocolParameters.coins_per_utxo_word.toString()));
                        datums = Loader_1.default.CSL.PlutusList.new();
                        redeemers = Loader_1.default.CSL.Redeemers.new();
                        plutusScripts = Loader_1.default.CSL.PlutusScripts.new();
                        transactionWitnessSet = Loader_1.default.CSL.TransactionWitnessSet.new();
                        outputs = Loader_1.default.CSL.TransactionOutputs.new();
                        // console.log(recipients);
                        for (_i = 0, recipients_1 = recipients; _i < recipients_1.length; _i++) {
                            recipient = recipients_1[_i];
                            txOutputBuilder = Loader_1.default.CSL.TransactionOutputBuilder
                                .new()
                                .with_address(Loader_1.default.CSL.Address.from_bech32(recipient.address));
                            txOutputAmountBuilder = txOutputBuilder.next();
                            lovelace = recipient.amount ? recipient.amount : "1000000";
                            outputValue = Loader_1.default.CSL.Value.new(Loader_1.default.CSL.BigNum.from_str(lovelace));
                            if ((recipient.assets && recipient.assets.length > 0)) {
                                multiAsset = CardanoWallet._makeMultiAsset(recipient.assets);
                                outputValue.set_multiasset(multiAsset);
                                minAda = Loader_1.default.CSL.min_ada_for_output(txOutputAmountBuilder
                                    .with_value(outputValue)
                                    .build(), dataCost);
                                if (Loader_1.default.CSL.BigNum.from_str(lovelace).compare(minAda) < 0) {
                                    outputValue.set_coin(minAda);
                                }
                            }
                            // add output
                            if (parseInt(outputValue.coin().to_str()) > 0) {
                                outputs.add(txOutputAmountBuilder
                                    .with_value(outputValue)
                                    .build());
                            }
                        }
                        payerUtxos = payer.cborUtxos.map(function (utxos) {
                            return Loader_1.default.CSL.TransactionUnspentOutput.from_bytes((0, util_1.HexToBuffer)(utxos));
                        });
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 7, , 8]);
                        newFee = fee;
                        _d.label = 4;
                    case 4:
                        if (!true) return [3 /*break*/, 6];
                        return [4 /*yield*/, coinSelection.select(payerUtxos, outputs, newFee, UTXO_LIMIT, CoinSelection_1.SelectionMode.BIGGER_FIRST)];
                    case 5:
                        selection = _d.sent();
                        remainingLovelace = selection.reamainingValue.coin();
                        alwaysNeedLovelace = Loader_1.default.CSL.BigNum.from_str("1000000").checked_add(Loader_1.default.CSL.BigNum.from_str(fee ? fee : "300000"));
                        needLovelace = alwaysNeedLovelace;
                        if (selection.reamainingValue.multiasset() !== undefined) {
                            txOutputBuilder = Loader_1.default.CSL.TransactionOutputBuilder
                                .new()
                                .with_address(Loader_1.default.CSL.Address.from_bech32(payer.address));
                            txOutputAmountBuilder = txOutputBuilder.next();
                            lovelace = Loader_1.default.CSL.BigNum.from_str("1000000");
                            outputValue = selection.reamainingValue;
                            outputValue.set_coin(lovelace);
                            minAda = Loader_1.default.CSL.min_ada_for_output(txOutputAmountBuilder
                                .with_value(outputValue)
                                .build(), dataCost);
                            if (lovelace.compare(minAda) < 0) {
                                outputValue.set_coin(minAda);
                            }
                            needLovelace = needLovelace.checked_add(outputValue.coin());
                            remainingLovelace = remainingLovelace.checked_sub(outputValue.coin());
                            if (remainingLovelace.compare(alwaysNeedLovelace) < 0) {
                                newFee = needLovelace.to_str();
                                return [3 /*break*/, 4];
                            }
                            // add output
                            // if (parseInt(outputValue.coin().to_str()) > 0) {
                            outputs.add(txOutputAmountBuilder
                                .with_value(outputValue)
                                .build());
                            // }
                        }
                        else if (remainingLovelace.compare(alwaysNeedLovelace) < 0) {
                            newFee = needLovelace.to_str();
                            return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_1 = _d.sent();
                        switch (err_1.message) {
                            case "BALANCE_EXHAUSTED":
                            case "INPUT_LIMIT_EXCEEDED":
                                throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.TRANSACTION_BUILDING_FAILED](err_1.message);
                            default:
                                throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.UNKNOWN](err_1.message);
                        }
                        return [3 /*break*/, 8];
                    case 8:
                        // console.log("selection:", selection);
                        for (i = 0; i < selection.input.length; ++i) {
                            txBuilder.add_input(selection.input[i].output().address(), selection.input[i].input(), selection.input[i].output().amount());
                        }
                        auxiliaryData = null;
                        if (metadata) {
                            auxiliaryData = Loader_1.default.CSL.AuxiliaryData.new();
                            generalTransactionMetadata_1 = Loader_1.default.CSL.GeneralTransactionMetadata.new();
                            Object.entries(metadata).map(function (_a) {
                                var label = _a[0], metadata = _a[1];
                                generalTransactionMetadata_1.insert(Loader_1.default.CSL.BigNum.from_str(label), Loader_1.default.CSL.encode_json_str_to_metadatum(JSON.stringify(metadata), 0));
                            });
                            auxiliaryData.set_metadata(generalTransactionMetadata_1);
                            txBuilder.set_auxiliary_data(auxiliaryData);
                        }
                        // Adding outputs
                        // console.log("adding outputs");
                        for (i = 0; i < outputs.len(); i++) {
                            txBuilder.add_output(outputs.get(i));
                        }
                        return [4 /*yield*/, ((_c = this.blockchainProvider) === null || _c === void 0 ? void 0 : _c.getLatestBlock(networkId))];
                    case 9:
                        now = (_d.sent()).slot;
                        txBuilder.set_ttl(now + ttl);
                        // TODO: add change address
                        // console.log("add_change_if_needed");
                        txBuilder.add_change_if_needed(Loader_1.default.CSL.Address.from_bech32(payer.address));
                        txBody = txBuilder.build();
                        transaction = Loader_1.default.CSL.Transaction.new(txBody, transactionWitnessSet, auxiliaryData);
                        serializedTx = (0, util_1.BufferToHex)(buffer_1.Buffer.from(transaction.to_bytes()));
                        // TODO: add check for size of tx
                        return [2 /*return*/, {
                                "rawTx": serializedTx,
                                "fee": txBody.fee().to_str(),
                                "other": [plutusScripts, datums, redeemers]
                            }];
                }
            });
        });
    };
    CardanoWallet.prototype.signTx = function (rawTx_1) {
        return __awaiter(this, arguments, void 0, function (rawTx, partialSign) {
            var signedTx, err_2;
            if (partialSign === void 0) { partialSign = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.walletApi.signTx(rawTx, partialSign)];
                    case 1:
                        signedTx = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        console.warn(err_2);
                        throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.API_CALL_FAILED]((err_2 === null || err_2 === void 0 ? void 0 : err_2.message) || (err_2 === null || err_2 === void 0 ? void 0 : err_2.info));
                    case 3: return [2 /*return*/, signedTx];
                }
            });
        });
    };
    CardanoWallet.prototype.submitTx = function (rawTx_1, witnesses_1) {
        return __awaiter(this, arguments, void 0, function (rawTx, witnesses, metadata) {
            var tx, txWitnesses, txVkeys, txScripts, addWitnesses, addVkeys, addScripts, totalVkeys, totalScripts, i, i, i, i, totalWitnesses, aux, generalMetadata, metadatas, _i, metadatas_1, m, signedTx, txHash, err_3;
            if (metadata === void 0) { metadata = undefined; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tx = Loader_1.default.CSL.Transaction.from_bytes((0, util_1.HexToBuffer)(rawTx));
                        txWitnesses = tx.witness_set();
                        txVkeys = txWitnesses.vkeys();
                        txScripts = txWitnesses.native_scripts();
                        addWitnesses = Loader_1.default.CSL.TransactionWitnessSet.from_bytes((0, util_1.HexToBuffer)(witnesses[0]));
                        addVkeys = addWitnesses.vkeys();
                        addScripts = addWitnesses.native_scripts();
                        totalVkeys = Loader_1.default.CSL.Vkeywitnesses.new();
                        totalScripts = Loader_1.default.CSL.NativeScripts.new();
                        if (txVkeys) {
                            for (i = 0; i < txVkeys.len(); i++) {
                                totalVkeys.add(txVkeys.get(i));
                            }
                        }
                        if (txScripts) {
                            for (i = 0; i < txScripts.len(); i++) {
                                totalScripts.add(txScripts.get(i));
                            }
                        }
                        if (addVkeys) {
                            for (i = 0; i < addVkeys.len(); i++) {
                                totalVkeys.add(addVkeys.get(i));
                            }
                        }
                        if (addScripts) {
                            for (i = 0; i < addScripts.len(); i++) {
                                totalScripts.add(addScripts.get(i));
                            }
                        }
                        totalWitnesses = Loader_1.default.CSL.TransactionWitnessSet.new();
                        totalWitnesses.set_vkeys(totalVkeys);
                        totalWitnesses.set_native_scripts(totalScripts);
                        if (metadata) {
                            aux = Loader_1.default.CSL.AuxiliaryData.new();
                            generalMetadata = Loader_1.default.CSL.GeneralTransactionMetadata.new();
                            metadatas = Object.entries(metadata);
                            for (_i = 0, metadatas_1 = metadatas; _i < metadatas_1.length; _i++) {
                                m = metadatas_1[_i];
                                generalMetadata.insert(Loader_1.default.CSL.BigNum.from_str(m[0]), Loader_1.default.CSL.encode_json_str_to_metadatum(JSON.stringify(m[1]), 0));
                            }
                            aux.set_metadata(generalMetadata);
                        }
                        else {
                            aux = tx.auxiliary_data();
                        }
                        return [4 /*yield*/, Loader_1.default.CSL.Transaction.new(tx.body(), totalWitnesses, aux)];
                    case 1:
                        signedTx = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.walletApi.submitTx(buffer_1.Buffer.from(signedTx.to_bytes(), "hex").toString("hex"))];
                    case 3:
                        txHash = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        console.warn(err_3);
                        throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.API_CALL_FAILED]((err_3 === null || err_3 === void 0 ? void 0 : err_3.message) || (err_3 === null || err_3 === void 0 ? void 0 : err_3.info));
                    case 5: return [2 /*return*/, txHash];
                }
            });
        });
    };
    CardanoWallet.prototype.estimateMaxBridgeAmount = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var networkId, _a, coinSelection, utxos;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getNetworkId()];
                    case 1:
                        networkId = _c.sent();
                        if (!!this.protocolParameters) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, ((_b = this.blockchainProvider) === null || _b === void 0 ? void 0 : _b.getProtocolParameters(networkId))];
                    case 2:
                        _a.protocolParameters = _c.sent();
                        _c.label = 3;
                    case 3:
                        coinSelection = new CoinSelection_1.default();
                        coinSelection.setProtocolParameters(this.protocolParameters.min_utxo.toString(), this.protocolParameters.min_fee_a.toString(), this.protocolParameters.min_fee_b.toString(), this.protocolParameters.max_tx_size.toString(), this.protocolParameters.coins_per_utxo_word.toString());
                        return [4 /*yield*/, this._getCborUtxos()];
                    case 4:
                        utxos = _c.sent();
                        return [2 /*return*/, coinSelection.findPossibleMax(token, utxos.map(function (utxo) { return Loader_1.default.CSL.TransactionUnspentOutput.from_bytes((0, util_1.HexToBuffer)(utxo)); }), UTXO_LIMIT)];
                }
            });
        });
    };
    CardanoWallet.prototype.bridge = function (asset_1, to_1, by_1) {
        return __awaiter(this, arguments, void 0, function (asset, to, by, options) {
            var networkId, _a, usedAddress, balance, payer, recipients, metadata, buildedTx, res, witness, fromTxHash_1, bp_1;
            var _b;
            var _this = this;
            var _c;
            if (options === void 0) { options = {
                isDemo: false,
                ttl: 3600
            }; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getNetworkId()];
                    case 1:
                        networkId = _d.sent();
                        _a = this;
                        return [4 /*yield*/, ((_c = this.blockchainProvider) === null || _c === void 0 ? void 0 : _c.getProtocolParameters(networkId))];
                    case 2:
                        _a.protocolParameters = _d.sent();
                        return [4 /*yield*/, this.getUsedAddresses()];
                    case 3:
                        usedAddress = (_d.sent())[0];
                        return [4 /*yield*/, this.getBalance()];
                    case 4:
                        balance = (_d.sent()).filter(function (b) { return b.unit === asset.token; })[0];
                        _b = {
                            address: usedAddress
                        };
                        return [4 /*yield*/, this._getCborUtxos()];
                    case 5:
                        payer = (_b.cborUtxos = _d.sent(),
                            _b);
                        recipients = [{
                                address: networkId
                                    ? bridge_1.bridgeConfigs[by][bridge_1.ChainName.Cardano][bridge_1.ChainName.Milkomeda].address
                                    : bridge_1.bridgeConfigs[by][bridge_1.ChainName.CardanoTestnet][bridge_1.ChainName.MilkomedaDevnet].address,
                                amount: asset.token == "lovelace" && !Loader_1.default.CSL.BigNum.from_str(asset.quantity).is_zero() ? asset.quantity : undefined,
                                assets: asset.token != "lovelace" && !Loader_1.default.CSL.BigNum.from_str(asset.quantity).is_zero() ? [{
                                        unit: asset.token,
                                        quantity: asset.quantity
                                    }] : undefined
                            }];
                        metadata = networkId
                            ? bridge_1.bridgeConfigs[by][bridge_1.ChainName.Cardano][bridge_1.ChainName.Milkomeda].metadata(to.address)
                            : bridge_1.bridgeConfigs[by][bridge_1.ChainName.CardanoTestnet][bridge_1.ChainName.MilkomedaDevnet].metadata(to.address);
                        return [4 /*yield*/, this.buildTx(payer, recipients, "300000", metadata, options.ttl, networkId)];
                    case 6:
                        buildedTx = _d.sent();
                        res = {
                            from: {
                                chain: networkId ? bridge_1.ChainName.Cardano : bridge_1.ChainName.CardanoTestnet,
                                fee: {
                                    token: "lovelace",
                                    quantity: buildedTx.fee,
                                    decimals: 6
                                }
                            },
                            to: {
                                chain: networkId ? bridge_1.ChainName.Milkomeda : bridge_1.ChainName.MilkomedaDevnet,
                                fee: {
                                    token: networkId ? "milkADA" : "milkTADA",
                                    quantity: "100000000000000000",
                                    decimals: 18
                                }
                            },
                            by: by
                        };
                        if (!!options.isDemo) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.signTx(buildedTx.rawTx)];
                    case 7:
                        witness = _d.sent();
                        return [4 /*yield*/, this.submitTx(buildedTx.rawTx, [witness], metadata)];
                    case 8:
                        fromTxHash_1 = _d.sent();
                        res.from.tx = {
                            hash: fromTxHash_1,
                            wait: function () {
                                var args_1 = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args_1[_i] = arguments[_i];
                                }
                                return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                    var _this = this;
                                    if (blockchainProvider === void 0) { blockchainProvider = this.blockchainProvider; }
                                    if (confirmations === void 0) { confirmations = 0; }
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                var _a;
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0:
                                                            if (!blockchainProvider) return [3 /*break*/, 2];
                                                            _a = resolve;
                                                            return [4 /*yield*/, blockchainProvider.getTxBlockHash(fromTxHash_1, networkId)];
                                                        case 1:
                                                            _a.apply(void 0, [_b.sent()]);
                                                            _b.label = 2;
                                                        case 2:
                                                            reject("BlockchainProvider is undefiend");
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); })];
                                    });
                                });
                            }
                        };
                        if (this.bridgeProvider) {
                            bp_1 = this.bridgeProvider;
                            res.to.tx = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var toTxHash;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, bp_1.getBridgeTxFor(fromTxHash_1, networkId)];
                                        case 1:
                                            toTxHash = _a.sent();
                                            resolve({
                                                hash: toTxHash,
                                                wait: function (blockchainProvider_1) {
                                                    var args_1 = [];
                                                    for (var _i = 1; _i < arguments.length; _i++) {
                                                        args_1[_i - 1] = arguments[_i];
                                                    }
                                                    return __awaiter(_this, __spreadArray([blockchainProvider_1], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                        var _this = this;
                                                        if (confirmations === void 0) { confirmations = 0; }
                                                        return __generator(this, function (_a) {
                                                            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                                    var _a;
                                                                    return __generator(this, function (_b) {
                                                                        switch (_b.label) {
                                                                            case 0:
                                                                                if (!blockchainProvider) return [3 /*break*/, 2];
                                                                                _a = resolve;
                                                                                return [4 /*yield*/, blockchainProvider.waitForTransaction(toTxHash)];
                                                                            case 1:
                                                                                _a.apply(void 0, [(_b.sent()).blockHash]);
                                                                                _b.label = 2;
                                                                            case 2:
                                                                                reject("BlockchainProvider is undefiend");
                                                                                return [2 /*return*/];
                                                                        }
                                                                    });
                                                                }); })];
                                                        });
                                                    });
                                                }
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        _d.label = 9;
                    case 9: return [2 /*return*/, res];
                }
            });
        });
    };
    CardanoWallet.prototype.bridgeExtra = function (assets_2, to_1, by_1) {
        return __awaiter(this, arguments, void 0, function (assets, to, by, options) {
            var networkId, _a, usedAddress, payer, recipients, metadata, buildedTx, res, witness, fromTxHash_2, bp_2;
            var _b;
            var _this = this;
            var _c;
            if (options === void 0) { options = {
                isDemo: false,
                ttl: 3600
            }; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getNetworkId()];
                    case 1:
                        networkId = _d.sent();
                        _a = this;
                        return [4 /*yield*/, ((_c = this.blockchainProvider) === null || _c === void 0 ? void 0 : _c.getProtocolParameters(networkId))];
                    case 2:
                        _a.protocolParameters = _d.sent();
                        return [4 /*yield*/, this.getUsedAddresses()];
                    case 3:
                        usedAddress = (_d.sent())[0];
                        _b = {
                            address: usedAddress
                        };
                        return [4 /*yield*/, this._getCborUtxos()];
                    case 4:
                        payer = (_b.cborUtxos = _d.sent(),
                            _b);
                        recipients = [{
                                address: networkId
                                    ? bridge_1.bridgeConfigs[by][bridge_1.ChainName.Cardano][bridge_1.ChainName.Milkomeda].address
                                    : bridge_1.bridgeConfigs[by][bridge_1.ChainName.CardanoTestnet][bridge_1.ChainName.MilkomedaDevnet].address,
                                amount: assets.gas && !Loader_1.default.CSL.BigNum.from_str(assets.gas).is_zero() ? assets.gas : undefined,
                                assets: assets.token && !Loader_1.default.CSL.BigNum.from_str(assets.token.quantity).is_zero() ? [{
                                        unit: assets.token.token,
                                        quantity: assets.token.quantity
                                    }] : undefined
                            }];
                        metadata = networkId
                            ? bridge_1.bridgeConfigs[by][bridge_1.ChainName.Cardano][bridge_1.ChainName.Milkomeda].metadata(to.address)
                            : bridge_1.bridgeConfigs[by][bridge_1.ChainName.CardanoTestnet][bridge_1.ChainName.MilkomedaDevnet].metadata(to.address);
                        return [4 /*yield*/, this.buildTx(payer, recipients, "300000", metadata, options.ttl, networkId)];
                    case 5:
                        buildedTx = _d.sent();
                        res = {
                            from: {
                                chain: networkId ? bridge_1.ChainName.Cardano : bridge_1.ChainName.CardanoTestnet,
                                fee: {
                                    token: "lovelace",
                                    quantity: buildedTx.fee,
                                    decimals: 6
                                }
                            },
                            to: {
                                chain: networkId ? bridge_1.ChainName.Milkomeda : bridge_1.ChainName.MilkomedaDevnet,
                                fee: {
                                    token: networkId ? "milkADA" : "milkTADA",
                                    quantity: "100000000000000000",
                                    decimals: 18
                                }
                            },
                            by: by
                        };
                        if (!!options.isDemo) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.signTx(buildedTx.rawTx)];
                    case 6:
                        witness = _d.sent();
                        return [4 /*yield*/, this.submitTx(buildedTx.rawTx, [witness], metadata)];
                    case 7:
                        fromTxHash_2 = _d.sent();
                        res.from.tx = {
                            hash: fromTxHash_2,
                            wait: function () {
                                var args_1 = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args_1[_i] = arguments[_i];
                                }
                                return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                    var _this = this;
                                    if (blockchainProvider === void 0) { blockchainProvider = this.blockchainProvider; }
                                    if (confirmations === void 0) { confirmations = 0; }
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                var _a;
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0:
                                                            if (!blockchainProvider) return [3 /*break*/, 2];
                                                            _a = resolve;
                                                            return [4 /*yield*/, blockchainProvider.getTxBlockHash(fromTxHash_2, networkId)];
                                                        case 1:
                                                            _a.apply(void 0, [_b.sent()]);
                                                            _b.label = 2;
                                                        case 2:
                                                            reject("BlockchainProvider is undefiend");
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); })];
                                    });
                                });
                            }
                        };
                        if (this.bridgeProvider) {
                            bp_2 = this.bridgeProvider;
                            res.to.tx = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var toTxHash;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, bp_2.getBridgeTxFor(fromTxHash_2, networkId)];
                                        case 1:
                                            toTxHash = _a.sent();
                                            resolve({
                                                hash: toTxHash,
                                                wait: function (blockchainProvider_1) {
                                                    var args_1 = [];
                                                    for (var _i = 1; _i < arguments.length; _i++) {
                                                        args_1[_i - 1] = arguments[_i];
                                                    }
                                                    return __awaiter(_this, __spreadArray([blockchainProvider_1], args_1, true), void 0, function (blockchainProvider, confirmations) {
                                                        var _this = this;
                                                        if (confirmations === void 0) { confirmations = 0; }
                                                        return __generator(this, function (_a) {
                                                            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                                                    var _a;
                                                                    return __generator(this, function (_b) {
                                                                        switch (_b.label) {
                                                                            case 0:
                                                                                if (!blockchainProvider) return [3 /*break*/, 2];
                                                                                _a = resolve;
                                                                                return [4 /*yield*/, blockchainProvider.waitForTransaction(toTxHash)];
                                                                            case 1:
                                                                                _a.apply(void 0, [(_b.sent()).blockHash]);
                                                                                _b.label = 2;
                                                                            case 2:
                                                                                reject("BlockchainProvider is undefiend");
                                                                                return [2 /*return*/];
                                                                        }
                                                                    });
                                                                }); })];
                                                        });
                                                    });
                                                }
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        _d.label = 8;
                    case 8: return [2 /*return*/, res];
                }
            });
        });
    };
    /* EVENT HANDLING */
    CardanoWallet.prototype.on = function (eventName, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var on;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_a.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        on = this.walletApi.on || this.walletApi.experimental.on;
                        if (!on) {
                            switch (eventName) {
                                case "accountChange":
                                    on = this.walletApi.onAccountChange;
                                    break;
                                case "networkChange":
                                    on = this.walletApi.onNetworkChange;
                                    break;
                                default:
                                    throw "unknown event";
                            }
                            if (!on) {
                                throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.UNSUPPORTED_METHOD](this.name(), "on(eventName, callback)");
                            }
                            on(callback);
                        }
                        else {
                            on(eventName, callback);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CardanoWallet.prototype.off = function (eventName, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var off;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabled()];
                    case 1:
                        if (!(_a.sent())) {
                            throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.NOT_CONNECTED_WALLET];
                        }
                        off = this.walletApi.off || this.walletApi.experimental.off;
                        if (!off) {
                            switch (eventName) {
                                case "accountChange":
                                    off = this.walletApi.offAccountChange;
                                    break;
                                case "networkChange":
                                    off = this.walletApi.offNetworkChange;
                                    break;
                                default:
                                    throw "unknown event";
                            }
                            if (!off) {
                                throw WalletError_1.WalletErrors[WalletError_1.WalletErrorCode.UNSUPPORTED_METHOD](this.name(), "off(eventName, callback)");
                            }
                            off(callback);
                        }
                        else {
                            off(eventName, callback);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CardanoWallet.supportedWallets = SUPPORTED_WALLETS;
    CardanoWallet.experimentalWallets = EXPERIMENTAL_WALLETS;
    CardanoWallet._initTxBuilder = function (protocolParameters) {
        // CardanoWallet._initTxBuilderV9(protocolParameters);
        // CardanoWallet._initTxBuilderV10(protocolParameters);
        return CardanoWallet._initTxBuilderV11(protocolParameters);
    };
    return CardanoWallet;
}());
exports.CardanoWallet = CardanoWallet;
